import { Injectable } from '@angular/core';
import { MenuItem } from '@app/interfaces';
import { MenuService } from '@app/services/menu/menu.service';

const AccountMenu: MenuItem[] = [
    {
        key: 'account.menu.personal',
        link: ['/account', 'personal'],
    },
    {
        key: 'account.menu.jobAndPay',
        link: ['/account', 'job-and-pay'],
    },
    {
        key: 'account.menu.reminders',
        link: ['/account', 'reminders'],
    },
    {
        key: 'account.menu.journey',
        link: ['/account', 'journey'],
    },
    {
        key: 'account.menu.account',
        link: ['/account', 'account'],
    },
];

@Injectable()
export class AccountMenuService extends MenuService {
    setBaseMenu(): void {
        this.baseMenu = AccountMenu;
    }
}
